/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const STEP_STATE_PENDING = 'pending';
export const STEP_STATE_ACTIVE = 'active';
export const STEP_STATE_DONE = 'done';

export const STAGE_STATES = {
  PENDING: STEP_STATE_PENDING,
  ACTIVE: STEP_STATE_ACTIVE,
  DONE: STEP_STATE_DONE,
};
